const DATA_LOGGER = 'DATA_LOGGER'
const ZEUSINT = 'ZEUSINT'

const PROVIDERS = [DATA_LOGGER, ZEUSINT]

const providers = {
    DATA_LOGGER,
    ZEUSINT,
    PROVIDERS,
}
export default providers
